let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5fPPA")).then(() => parcelRequire('b9R9h'));